import React, { useEffect } from 'react';

const NextArrowSlider = (props) => {
    const { className, onClick, setNextIndex, currentSlide } = props;        
    
    useEffect(() => {
        setNextIndex(currentSlide);
    }, [currentSlide]);

    return (
        <button type="button" className={className} onClick={onClick}></button>
    )
}

export default NextArrowSlider;